/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'
import interceptorsSetup  from '@/middleware/interceptors'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)
// Vue.use(interceptorsSetup)

import moment from 'moment';

import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'

Vue.use(Datetime)


// Vue validation
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required, email, min, max } from 'vee-validate/dist/rules'

// VueNativeNotification
import VueNativeNotification from 'vue-native-notification'


// Add a rule.
extend('required', {
  ...required,
  message: 'This field is required'
})
extend('file_required', {
  ...required,
  message: 'Please upload a file'
})
extend('min', {
  ...min,
  message: 'This field must have no less than {length} characters'
})
extend('max', {
  ...max,
  message: 'This field must have no more than {length} characters'
})
extend('tel', {
  validate: value => value.match(/^[0-9]*$/u),
  message: 'Telephone Number must not contain any letter or special character'
})

extend('fax', {
  validate: value => value.match(/^[0-9]*$/u),
  message: 'Fax No must not contain any letter or special character'
})

extend('email', email)

extend('no_whitespace', {
  validate: value => value.match(/^\S*$/u),
  message: 'Password must not contain whitespace'
})
extend('min_tel', {
  validate: value => value.length > 6,
  message: 'Contact number must contain at least 7 numbers.'
})
extend('max_tel', {
  validate: value => value.length < 17,
  message: 'Contact number allowed only 16 numbers '
})
extend('contactNumber', {
  validate: value => value.match(/^[+]{0,1}[0-9]*$/g),
  message: 'Enter a valid contact number '
})


extend('g2fa', {
  validate: value => value.length  === 6,
  message: 'Login code must include 6 numbers '
})

extend('one_uppercase', {
  validate: value => value.match(/[a-z]/),
  message: 'Password must contain at least one Lowercase character'
})
extend('one_lowercase', {
  validate: value => value.match(/[A-Z]/),
  message: 'Password must contain at least one Uppercase character'
})
extend('selected', {
  ...required,
  message: 'Select at least one clinic.'
})

extend('one_number', {
  validate: value => value.match(/[0-9]/),
  message: 'Password must contain at least one numeral'
})

extend('one_special', {
  validate: value => value.match(/[$&+,:;=?@#|'<>.^*()%!-]/),
  message: 'Password must contain at least one special character'
})

extend('same_password', {
  params: ['target'],
  validate (value, { target }) {
    return value === target
  },
  message: 'Password confirmation should be matched'
})

extend('min_than', {
  params: ['target'],
  validate (value, { target }) {
    if (!!target) {
      return Number(value) < Number(target)
    } else {
      return true
    }
  },
  message: `The MOQ must be smaller than the MaxOQ`
})
extend('max_than', {
  params: ['target'],
  validate (value, { target }) {
    if (!!target) {
      return Number(value) > Number(target)
    } else {
      return true
    }
  },
  message: `The MOQ must not be larger than MaxOQ`
})

extend('cross_over_max', {
  params: ['target'],
  validate (value, { target }) {
    if (!!target) {
      return Number(value) > Number(target)
    } else {
      return true
    }
  },
  message: `The MOQ must be lager than previous MaxOQ`
})

extend('maxoq_rm', {
  params: ['target'],
  validate (value, { target }) {
    return Number(value) <= Number(target)
  },
  message(value, { target }) {
    return `MAXOQ in nimble is 1,000,000`
  }
})

extend('moq', {
  params: ['target'],
  validate (value, { target }) {
    return Number(value) >= Number(target)
  },
  message(value, { target }) {
    return `The MOQ is ${target}`
  }
})

// Register it globally
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)

Vue.mixin({
  methods: {
    __dateTimeFormatter:function(Date){
      if(Date){
        // return moment(Date).format("DD-MMM-YYYY HH:MM")
        return moment.utc(Date).local().format('DD/MM/YYYY HH:mm:ss')
      }
      else{
        return ""
      }
    },
    __nameSplitter: function(link) {
      if (link) {
        let fields = link.split('/');
        const file_full_name = fields[fields.length - 1]
        let second_field = file_full_name.split('-')
        return second_field[second_field.length -1 ]
      } else {
        return 'No file uploaded'
      }
    },
    __isDisabledRawMaterial: function (status) {
      return status.status.id === 2 || status.status.id === 3 || !this.$can('edit-raw-material');
    },
    __isDisabledSites: function() {
      return !this.$can('edit-site')
    }
  }
})

// axios
import axios from './axios.js'
Vue.prototype.$http = axios

// Filters
import './filters/filters.js'


// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

// Vue Laravel acl
import laravel_acl from './plugins/laravel-acl'
Vue.use(laravel_acl, router)

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

Vue.use(VueNativeNotification, {
  requestOnNotify: true
})

// Feather font icon
require('./assets/css/iconfont.css')


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
